import './skeleton.css'

type TransactionsSkeletonProps = {
  rows: number
}

export default function TransactionsSkeletonV2({ rows }: TransactionsSkeletonProps) {
  const skeletonRows = Array.from({ length: rows })

  return (
    <div className='flex flex-col w-full'>
      {skeletonRows.map((_, index) => (
        <div key={index} className={`flex gap-4 ${index === 0 ? '' : 'pt-3'} items-center`}>
          <div>
            {/* Fund logo skeleton */}
            <div className='w-max h-max overflow-hidden'>
              <div className='skeleton rounded-xl h-10 w-10' />
            </div>
          </div>
          <div className={`flex w-1 flex-1 border-b border-[#EBF2F2] pb-4 ${index === rows - 1 ? 'border-b-0' : ''}`}>
            {/* Fund name and transaction amount */}
            <div className='flex flex-col gap-1 w-1 flex-1 pr-1'>
              {/* Source indicator skeleton */}
              <div className='flex items-center gap-1 pt-[5px] pb-2'>
                <div className='skeleton h-[12px] w-[12px] rounded-sm' />
                <div className='skeleton h-[12px] w-[50px]' />
              </div>
              {/* Fund name skeleton */}
              <div className='max-w-[98%] truncate'>
                <div className='skeleton h-[13px] w-[150px]' />
              </div>
              {/* Transaction amount and type skeleton */}
              <div className='flex gap-2'>
                <div className='skeleton h-[28px] w-[120px]' />
                <div className='skeleton rounded-[8px] h-[21px] w-[36px]' />
              </div>
            </div>
            {/* Timestamp skeleton */}
            <div className='text-[13px] font-[400] text-[#8E9393] pr-5 pt-[25.5px]'>
              <div className='skeleton h-[13px] w-[70px]' />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
